import React from 'react';
import { List } from 'framework/list';
import { useEducationService, useEmployeeId } from 'domain/shared/employee';
import EducationListContent from '../List/EducationListContent';
import Prepopulation from 'domain/people/employee/prepopulation/Prepopulation';
import { Education } from '../shared/types';

const LS_KEY = 'HigherEducationList';

const EmployeeHigherEducationSummary = () => {
  const { search } = useEducationService();
  const employeeId = useEmployeeId();

  if (!employeeId) return null;

  const mapEducationResponse = (response: {
    info?: { data?: { educations?: Education[] } };
    artifacts?: unknown[];
  }) => {
    return {
      ...response,
      educations: response?.info?.data?.educations || [],
      artifacts: response?.artifacts || [],
    };
  };

  return (
    <Prepopulation mapResponse={mapEducationResponse}>
      <List
        getDataMethod={search}
        defaultSortOrder="DESC"
        defaultSortField="graduationYear"
        localStorageKey={LS_KEY}
        disableUrlUpdate
      >
        <EducationListContent />
      </List>
    </Prepopulation>
  );
};

export default EmployeeHigherEducationSummary;
